function resolveTicketsBaseUrl(): string {
  if (location.hostname === 'localhost') return 'http://localhost:5173'
  if (location.hostname.includes('staging')) return 'https://tickets-staging.norm.eu'
  return 'https://tickets.norm.eu'
}

export const ticketsBaseUrl = resolveTicketsBaseUrl()
